import React, { useCallback, useEffect, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import SideNav from "components/SideNav";
import Footer from "components/Footer";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { db, storage } from "../firebase/firebase";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { v4 } from "uuid";
import { upload } from "@testing-library/user-event/dist/upload";
import ExerciseDataPicker from "components/ExerciseDataPicker";
import { useDropzone } from "react-dropzone";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Link, Routes, Route, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Any } from "@react-spring/types";

export default function CreateWorkout() {
  const [groups, setGroups] = useState(null);
  const selPage = "workouts";

  const loadPermission = async (urlVar) => {
    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      if (doc.data().isAdmin) {
        setIsAdmin(true);
      }

      setGroups(doc.data().permission_groups);
      setSelGroup(doc.data().permission_groups[0]);
    });
  };

  useEffect(() => {
    const getUser = async () => {
      const auth = await getAuth();

      onAuthStateChanged(auth, (user) => {
        if (user) {
          loadPermission(user.uid);
        } else {
          window.location.replace("/");
        }
      });
    };
    getUser();
  }, []);

  const onDrop = useCallback((acceptedFiles) => {
    var ending = acceptedFiles[0].name
      .slice(((acceptedFiles[0].name.lastIndexOf(".") - 1) >>> 0) + 2)
      .toLowerCase();

    if (
      ending != "jpg" &&
      ending != "jpeg" &&
      ending != "png" &&
      ending != "mp4"
    ) {
      alert("Bitte ein Bild oder mp4 hochladen.");
    } else {
      setImageUpload(acceptedFiles[0]);
      uploadImage(acceptedFiles[0]);
    }
  }, []);

  const navigate = useNavigate();

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [muscleGroup, setMuscleGroup] = useState(0);
  const [pulse, setPulse] = useState(0);
  // const [tempId, setTempId] = useState("");
  const [imageUpload, setImageUpload] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingValue, setLoadingValue] = useState(0);
  const [uploadedData, setUploadedData] = useState(false);
  const [mediaLink, setMediaLink] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [isPublic, setIsPublic] = useState(false);
  const [selGroup, setSelGroup] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  const createWorkout = async () => {
    if (
      desc == "" ||
      name == "" ||
      // tempId == "" ||
      mediaLink == "" ||
      mediaUrl == ""
    ) {
      alert("Bitte geben sie alle Felder an.");
    } else {
      try {
        var dataName = name + "_" + v4();

        const docRef = doc(db, "exercise_templates", dataName);

        var groupsSave = [];
        groupsSave.push(selGroup);

        await setDoc(docRef, {
          desc_de: desc,
          name_de: name,
          muscle_group: muscleGroup,
          hr_zone: pulse,
          template_id: dataName,
          media_link: mediaLink,
          media_url: mediaUrl,
          isActive: true,
          isPublic: isPublic ? isPublic : false,
          permission_groups: groupsSave,
        }).then(() => {
          setTimeout(() => {
            window.location.replace("workouts");
          });
        });
      } catch (err) {
        alert("Error adding document: ");
        alert("" + err);
        console.error("Error adding document: ", err);
      }
    }
  };

  const uploadImage = async (data) => {
    var sendData = imageUpload;

    if (imageUpload == null && data == null) return;

    if (sendData == null) {
      sendData = data;
    }

    setIsLoading(true);

    var dataName = sendData.name + "_" + v4();

    const storage = getStorage();
    const storageRef = ref(storage, `exercises/${dataName}`);

    setMediaUrl(dataName);

    const uploadTask = uploadBytesResumable(storageRef, sendData);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setLoadingValue(progress);
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
        }
      },
      (error) => {
        alert("Fehler bei Hochladen: " + error);
      },
      () => {
        setUploadedData(true);
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setMediaLink(downloadURL);
          console.log("File available at", downloadURL);
        });
      }
    );
  };

  function handleKeyDown(e) {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
  }

  useEffect(() => {}, []);

  const onName = (event) => {
    const result = event.target.value;
    setName(result);
  };

  const Content = () => (
    <section className="home-section">
      <div className="text">Workout erstellen</div>

      {/* Plan Data */}
      <section
        style={{ backgroundColor: "#ecf5ff" }}
        className={"plan-data"}
        id="plan-data"
      >
        <div className="container">
          <h2>Gib Informationen über die Übung ein</h2>
          <form className="contact-form">
            <p>Name:</p>
            <input
              value={name}
              onChange={(evt) => {
                onName(evt);
              }}
              type="search"
              placeholder="Name"
              key="name"
            />
            <p>Beschreibung:</p>
            <textarea
              onKeyDown={(keydown) => {
                handleKeyDown(keydown);
              }}
              value={desc}
              onChange={(evt) => {
                setDesc(evt.target.value);
              }}
              className="plan-desc"
              placeholder="Beschreibung"
              key="desc"
            ></textarea>
            {/* <p>{"Kürzel:"}</p>
            <input
              value={tempId}
              onChange={(evt) => {
                setTempId(evt.target.value);
              }}
              type="search"
              placeholder="z.B. bicyclecrunches"
              key="tempid"
            /> */}
            <p>Muskelgruppe</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={muscleGroup}
              onChange={(evt) => {
                setMuscleGroup(Number(evt.target.value));
              }}
            >
              <option value="0">Ganzkörper</option>
              <option value="1">Brust</option>
              <option value="2">Rücken</option>
              <option value="3">Bauch</option>
              <option value="4">Beine</option>
            </select>

            <div style={{ height: 20 }}></div>

            {isAdmin && (
              <a
                style={{ cursor: "pointer", marginTop: 20 }}
                onClick={() => {
                  setIsPublic(!isPublic);
                }}
              >
                <div className="list-container">
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderBottom: "1px solid hsl(210, 14%, 83%)",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                    className="list-item"
                  >
                    <p
                      style={{
                        padding: 2,
                        border: "1px solid hsl(210, 14%, 83%)",
                        marginRight: 15,
                        marginLeft: 10,
                        backgroundColor: "#fff",
                      }}
                    >
                      <FontAwesomeIcon
                        style={{ color: isPublic ? "#21252b" : "transparent" }}
                        icon={icon({ name: "check", style: "solid" })}
                      />
                    </p>
                    <p style={{ color: "#000", fontSize: 14 }}>
                      {"Öffentlich"}
                    </p>
                  </div>
                </div>
              </a>
            )}

            <p>Pulsbereich</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={pulse}
              onChange={(evt) => {
                setPulse(Number(evt.target.value));
              }}
            >
              <option value="0">Keiner</option>
              <option value="1">Recom</option>
              <option value="2">GA 1</option>
              <option value="3">Ga 2</option>
              <option value="4">EB</option>
              <option value="5">SB</option>
            </select>

            <p>Gruppe</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={selGroup}
              onChange={(evt) => {
                setSelGroup(evt.target.value);
              }}
            >
              {groups?.map((obj) => {
                return <option value={obj}>{obj}</option>;
              })}
            </select>

            <p>Video/Bild</p>

            <div {...getRootProps()}>
              <input {...getInputProps()} />
              {uploadedData ? (
                <>
                  <div
                    className={
                      "dropzone " + (isDragActive ? "active-dropzone" : "")
                    }
                    style={{ padding: 30 }}
                  >
                    <i
                      style={{
                        color: "#fff",
                        backgroundColor: "#7a3260",
                        borderRadius: 999,
                        padding: 10,
                      }}
                      className="fa-solid fa-check"
                    >
                      <FontAwesomeIcon
                        style={{ width: 60, height: 60 }}
                        icon={icon({ name: "check", style: "solid" })}
                      />
                    </i>
                    <span>{imageUpload.name}</span>
                  </div>
                </>
              ) : isLoading ? (
                <div
                  className={
                    "dropzone " + (isDragActive ? "active-dropzone" : "")
                  }
                  style={{ padding: 30 }}
                >
                  <CircularProgressbar value={loadingValue} />
                  <span>Datei wird hochgeladen...</span>
                </div>
              ) : (
                <>
                  <div
                    className={
                      "dropzone " + (isDragActive ? "active-dropzone" : "")
                    }
                  >
                    <span>Drag and Drop</span>
                    <span>oder</span>
                    <label htmlFor="dropzoneFile">Datei auswählen</label>
                    <input
                      onChange={(evt) => {
                        var ending = evt.target.files[0].name
                          .slice(
                            ((evt.target.files[0].name.lastIndexOf(".") - 1) >>>
                              0) +
                              2
                          )
                          .toLowerCase();

                        if (
                          ending != "jpg" &&
                          ending != "jpeg" &&
                          ending != "png" &&
                          ending != "mp4"
                        ) {
                          alert("Bitte ein Bild oder mp4 hochladen.");
                        } else {
                          setImageUpload(evt.target.files[0]);
                          uploadImage(evt.target.files[0]);
                        }
                      }}
                      type="file"
                      id="dropzoneFile"
                    />
                  </div>
                </>
              )}
            </div>
          </form>

          <div style={{ display: "flex" }} className="form-button">
            <button
              onClick={createWorkout}
              className="btn submit-form"
              type="submit"
            >
              Erstellen
            </button>

            <div style={{ width: 10 }}></div>

            <button
              onClick={() => navigate(-1)}
              className="btn btn-gray submit-form"
              type="submit"
            >
              Abbrechen
            </button>
          </div>
        </div>
      </section>
    </section>
  );

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>

      <div style={{ display: "none" }}>{ExerciseDataPicker()}</div>

      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
